import { React, Component, Container } from 'utils';
import { GiveawayStore, Creators } from 'model';
import './giveaway.less';

class Giveaway extends Component {

	static getStores() {
		return [ GiveawayStore ];
	}

	static calculateState() {
		return {
			giveaway: GiveawayStore.getSelected()
		}
	}

	handleClick = () => {
		var { giveaway } = this.state;
		var { standId } = this.props;

		Creators.prizeChanged({ giveaway, standId });
		window.dataLayer.push({
			event: "treasure_hunt_click",
		});
	}

	render() {
		var { giveaway } = this.state;

		if(giveaway) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "treasure_hunt_appear",
			});
			return <span className="giveaway" onClick={ this.handleClick }>
				<img src={ giveaway.imageUrl } />
			</span>
		} else {
			return null;
		}
	}

}

export default Container.create(Giveaway, { withProps: true });



// WEBPACK FOOTER //
// ./src/modules/components/giveaway.js